(function($) {

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/

function show_place_by_address(address) {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({'address': address}, function(results, status) {
        if(status == google.maps.GeocoderStatus.OK) {
            if(results[0]) {
                var location = results[0].geometry.location;
                acf.fields.google_map.update(location.lat(), location.lng()).center();
            } else {
                //alert("No results found");
            }
        } else {
            //alert("Geocoder failed due to: " + status);
        }
    });

}

function center_to_address() {
    var address = $('#acf-field_586bb6359a5b6').val() + ", Polska";
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({'address': address}, function(results, status) {
        if(status == google.maps.GeocoderStatus.OK) {
            if(results[0]) {
                center_map(results[0]);
            } else {
                //alert("No results found");
            }
        } else {
            //alert("Geocoder failed due to: " + status);
        }
    });
}

function center_map(place) {
    // If the place has a geometry, then present it on a map.
    if (place.geometry.viewport) {
        acf.fields.google_map.map.fitBounds(place.geometry.viewport);
    } else {
        acf.fields.google_map.map.setCenter(place.geometry.location);
        acf.fields.google_map.map.setZoom(17);  // Why 17? Because it looks good.
    }
}
    
    

function update_map() {
    var city = $('#acf-field_586bb6359a5b6').val();

    if (city === null || city === undefined || city == "") {
        return;
    }

    var address = $('#acf-field_586bb8449a5bc').val() + ", " + city;
    show_place_by_address(address);
}

$(document).ready(function(){
    var autocomplete_opts = {
        componentRestrictions: {country: 'pl'},
        types: ['(cities)']
    };
    var input_addr = document.getElementById('acf-field_586bb6359a5b6');
    var autocomplete_addr = new google.maps.places.Autocomplete(input_addr, autocomplete_opts);

    $('#acf-field_586bb6359a5b6').keypress(function(e) {
        if (e.keyCode == '13') {
            e.preventDefault();
            center_to_address();

        }
    });

    $('#acf-field_586bb6359a5b6').change(center_to_address);

    $('#acf-field_586bb8449a5bc').keypress(function(e) {
        if (e.keyCode == '13') {
            e.preventDefault();
            update_map();
        }
    });

    $('#acf-field_586bb8449a5bc').change(function(e) {
        update_map();
    })

    autocomplete_addr.addListener('place_changed', function() {
        var place = autocomplete_addr.getPlace();
        if (!place.geometry) {
            return;
        }

        $("#acf-field_586bb6359a5b6").val(place.address_components[0].long_name);
        center_map(place);
    });


});

})(jQuery);